import { useEffect, useState } from "react";
import "./App.css";
import HouseCardsBlock from "./modules/HouseCardsBlock/HouseCardsBlock";
import { useInView } from "react-intersection-observer";
import { BrowserRouter } from "react-router-dom";

function App({ isHistory, container }) {
  let picturesFeature = container.getAttribute("pictures-feature");
  if (picturesFeature !== "true") picturesFeature = "false";
  const [isPicturesFeature, setIsPicturesFeature] = useState(picturesFeature);
  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger once when entering the viewport
  });

  const mutationCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type !== "attributes" ||
        mutation.attributeName !== "pictures-feature"
      ) {
        return;
      }
      setIsPicturesFeature(
        // prev_value: mutation.oldValue,
        mutation.target.getAttribute("pictures-feature")
      );
    }
  };

  const observer = new MutationObserver(mutationCallback);
  observer.observe(container, { attributes: true });

  document.addEventListener("RTUnlockPremiumFeatures", function (event) {
    setIsPicturesFeature("true");
  });
  return (
    <BrowserRouter>
      <div className="App" ref={ref}>
        {inView && (
          <HouseCardsBlock
            isHistory={isHistory}
            container={container}
            isPicturesFeature={isPicturesFeature}
          />
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
